// ---------------------------------------------------------------------------
// Estratto VERBATIM da TabContratti.tsx (Task #3874 — split interno Fase 2).
// Nessuna modifica logica: JSX spostato tale e quale, stato e handler restano
// nel componente padre e arrivano via props esplicite.
// ---------------------------------------------------------------------------
// Task #3875 — DTO risposta condivisi (alias per minimizzare il churn).
import type { CrmMasterContract as Contract } from '@easyflow/shared';
import { contractPipelineStages } from '../shared';

interface ContractsKanbanProps {
  pipelineContracts: Contract[];
  handlePipelineStatusChange: (contractId: string, newStatus: string) => Promise<void>;
}

export function ContractsKanban({ pipelineContracts, handlePipelineStatusChange }: ContractsKanbanProps) {
  return (
        <div className="overflow-x-auto pb-4">
          <div className="flex gap-3 min-w-max">
            {contractPipelineStages.map(stage => {
              const stageContracts = pipelineContracts.filter(c => c.contract_pipeline_status === stage.key);
              return (
                <div key={stage.key} className={`w-64 bg-white dark:bg-gray-800 border border-border dark:border-gray-700 rounded-xl overflow-hidden border-t-4 ${stage.border}`}>
                  <div className="p-3 bg-muted/50 dark:bg-gray-700/50 flex items-center justify-between">
                    <div className="flex items-center gap-2">
                      <span className="text-lg">{stage.icon}</span>
                      <span className="text-foreground dark:text-white text-sm font-semibold">{stage.label}</span>
                    </div>
                    <span className="text-muted-foreground dark:text-muted-foreground/70 text-xs font-mono bg-gray-200 dark:bg-gray-600 px-2 py-0.5 rounded-full">{stageContracts.length}</span>
                  </div>
                  <div className="p-2 space-y-2 max-h-96 overflow-y-auto min-h-[100px]">
                    {stageContracts.length === 0 ? (
                      <p className="text-muted-foreground/70 text-xs text-center py-4">Nessun contratto</p>
                    ) : stageContracts.map(c => (
                      <div key={c.id} className="bg-muted/50 dark:bg-gray-700/50 border border-border dark:border-gray-600 rounded-lg p-3 hover:shadow-md transition-shadow">
                        <p className="text-foreground dark:text-white text-sm font-medium truncate">{c.tenant_name}</p>
                        <p className="text-muted-foreground dark:text-muted-foreground/70 text-xs font-mono">{c.contract_number}</p>
                        {c.quote_total_gross && <p className="text-green-400 text-xs font-semibold mt-1">€ {Number(c.quote_total_gross).toFixed(2)}</p>}
                        <div className="flex items-center gap-1 mt-2 text-xs text-muted-foreground/70">
                          {c.start_date && <span>{new Date(c.start_date).toLocaleDateString('it-IT')}</span>}
                          {c.start_date && c.end_date && <span>→</span>}
                          {c.end_date && <span>{new Date(c.end_date).toLocaleDateString('it-IT')}</span>}
                        </div>
                        <div className="mt-2 flex gap-1 flex-wrap">
                          {contractPipelineStages.filter(s => s.key !== stage.key).map(s => (
                            <button key={s.key} onClick={() => handlePipelineStatusChange(c.id, s.key)}
                              className="text-[10px] px-1.5 py-0.5 rounded bg-gray-200 dark:bg-gray-600 text-muted-foreground dark:text-muted-foreground/60 hover:bg-blue-500/20 hover:text-blue-400 transition-colors">
                              {s.icon}
                            </button>
                          ))}
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
  );
}
